<mat-card class="flex-col flex">
    <mat-card-header>
        <div mat-card-avatar class="cb-card-avatar-icon mat-mdc-header-card-avatar">
            @if (mappedItem?.stepFinanceInfoComplete) {
                <mat-icon class="cb-primary" title="Complete"> check_circle </mat-icon>
            }
            @if (!mappedItem?.stepFinanceInfoComplete) {
                <mat-icon class="cb-error" title="Incomplete"> error </mat-icon>
            }
        </div>
        <mat-card-title [ngClass]="!mappedItem?.stepFinanceInfoComplete ? 'cb-error' : ''">
            4. Finance Information
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="start-start flex-col flex">
        <cb-currency
            label="Budget"
            name="budget"
            [(ngModel)]="mappedItem.budget"
            [inclGst]="true"
            [readonly]="true"
        >
        </cb-currency>
        <cb-display-value-new label="Client has Finance?">
            {{ mappedItem?.hasFinance ? 'Yes' : 'No' }}
        </cb-display-value-new>
        @if (mappedItem.hasFinance) {
            <cb-display-value-new label="Finance Type">
                {{ mappedItem?.financeIsCash ? 'Cash' : 'Finance' }}
            </cb-display-value-new>
        }
        @if (mappedItem.hasFinance && !mappedItem.financeIsCash) {
            <div class="flex-col">
                <cb-display-value-new label="bankName">
                    {{ mappedItem?.bank }}
                </cb-display-value-new>
                <cb-checkbox
                    name="hasApproval"
                    label="Finance Pre-Approved?"
                    [readonly]="true"
                    [(ngModel)]="mappedItem.hasApproval"
                >
                </cb-checkbox>
            </div>
        }
    </mat-card-content>
    @if (canEdit && !mappedItem.isQualified()) {
        <div>
            <mat-divider class="card-divider"></mat-divider>
        </div>
    }
    @if (canEdit && !mappedItem.isQualified()) {
        <mat-card-actions class="end-center flex-row">
            <button mat-stroked-button color="accent" (cbClick)="editFinanceInfo()">
                <mat-icon>edit</mat-icon>
                &nbsp;Edit
            </button>
        </mat-card-actions>
    }
</mat-card>
